function arrayToMap(array){
  if(!Array.isArray(array)) return {};
  const result = {};
  for(let i = 0; i < array.length; i++){
    result[array[i].id] = array[i];
  }
  return result;
}

export default arrayToMap;